import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "../packages/excalidraw/css/styles.scss";
import "./index.scss";
import "./auth/auth.scss";

import { AuthApp } from "./auth/AuthApp";

const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    <AuthApp />
  </StrictMode>,
);
